module.exports = __webpack_public_path__ + "img/Valoris_120X35.8fe85467.png";